import React from 'react';

import { showDateNoTimeAsDateOnly } from '@libs/NwMoment';

import NwDrawer from '@components/Gui/NwDrawer';
import NwIcon from '@components/Gui/NwIcon';

import BirthdayItem from './BirthdayItem';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const BirthdaysDrawer = ({ birthdays, onClose }) => {
    return (
        <NwDrawer title="Birthdays" onClose={onClose}>
            <h2>
                <NwIcon icon={byPrefixAndName.fasl['birthday-cake']} />
                &nbsp;&nbsp;
                {birthdays && birthdays.length > 0 ? showDateNoTimeAsDateOnly(birthdays[0].BirthDate, false) : ''}
            </h2>
            <br />
            {birthdays.map((birthday, index) => (
                <div
                    style={{ paddingBottom: '1rem', marginBottom: '1rem', borderBottom: '1px solid #e8e8e8' }}
                    key={`birthday-${birthday.ID}-${index}`}
                >
                    <BirthdayItem birthday={birthday} />
                </div>
            ))}
        </NwDrawer>
    );
};

export default BirthdaysDrawer;
